import { move } from '@dnd-kit/helpers'
import { DragDropProvider } from '@dnd-kit/react'
import { SortableItem } from './SortableItem'
import { SortableListItem } from './types'

export function SortableList({
  items,
  isDisabled,
  onChange,
}: {
  items: SortableListItem[]
  isDisabled?: boolean
  onChange: (items: string[]) => void
}): React.ReactNode {
  function handleDelete(key: string) {
    onChange(items.filter(({ id }) => id !== key).map((item) => item.id))
  }

  return (
    <DragDropProvider
      onDragEnd={(event) =>
        onChange(
          move(
            items.map((item) => item.id),
            event,
          ),
        )
      }
    >
      {items.map((item, index) => (
        <SortableItem key={item.id} item={item} index={index} onDelete={handleDelete} isDisabled={isDisabled} />
      ))}
    </DragDropProvider>
  )
}
